let isNflEnabled: boolean | undefined;

const checkIfNflAvailableEnabled = () => {
    if (isNflEnabled !== undefined) {
        return isNflEnabled;
    }

    try {
        isNflEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ar_nfl_available'
        );

        return isNflEnabled;
    } catch (_err) {
        return false;
    }
};


export {
    checkIfNflAvailableEnabled
};